module.exports = __webpack_public_path__ + "static/kuchnia-photo01-a0f7868dc6348b8c0ff0b820373e0abb.jpg";